module.exports = __webpack_public_path__ + "static/media/Greifswald_banner.12e17bbf.jpg";